module.exports = __webpack_public_path__ + "static/media/video.cf1687a7.mp4";